var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33654 20.4297H21.3135C21.5313 20.4297 21.7422 20.353 21.9091 20.213C22.0761 20.073 22.1883 19.8787 22.2261 19.6641L24.8553 7.6188C24.8883 7.42059 24.856 7.21701 24.7632 7.03876C24.6704 6.86051 24.5222 6.71726 24.3409 6.6306C24.1596 6.54393 23.955 6.51856 23.7581 6.5583C23.5611 6.59804 23.3824 6.70074 23.2488 6.85092L18.3844 12.0906L13.6659 1.51044C13.5916 1.34998 13.4729 1.21411 13.324 1.1189C13.175 1.02368 13.0018 0.973083 12.825 0.973083C12.6482 0.973083 12.4751 1.02368 12.3261 1.1189C12.1771 1.21411 12.0584 1.34998 11.9841 1.51044L7.26563 12.0906L2.40118 6.85092C2.26795 6.69855 2.08849 6.594 1.89023 6.55324C1.69198 6.51249 1.48583 6.53777 1.3033 6.62523C1.12077 6.71269 0.971893 6.85751 0.879431 7.03755C0.78697 7.2176 0.756007 7.42297 0.791276 7.62228L3.4204 19.6676C3.45908 19.8821 3.57214 20.0761 3.7397 20.2155C3.90725 20.3548 4.11858 20.4307 4.33654 20.4297Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.8f975409241df8fcb0dde060fc771d24.svg";
export { ForwardRef as ReactComponent };